class Datalayer {
    static push(data) {
        if( !data.startsWith('?') ) data = `?${data}`;

        const params = new URLSearchParams(data)

        const layer = {
            event: params.get('event') || 'br_event',
            eventCategory: params.get('eventCategory') || 'page_engagement',
            eventAction: params.get('eventAction'),
            eventLabelA: params.get('eventLabelA'),
            eventLabelB: params.get('eventLabelB'),
            eventFunnelStage: params.get('eventFunnelStage') || 'conversion',
            eventValue: params.get('eventValue') || '',
        }

        window.dataLayer = window.dataLayer || []
        window.dataLayer.push(layer)
    }
}

window.addEventListener('DOMContentLoaded', function() {
    const elems = [ ...document.querySelectorAll('[data-dl]') ];

    const allowed_actions = [ 'click', 'submit' ]

    for( const el of elems ) {
        const trigger = el.getAttribute('data-dltrigger') || 'click'

        if( !allowed_actions.includes(trigger) ) continue

        const layer = el.getAttribute('data-dl')

        if( !layer ) continue

        el.addEventListener(trigger, _e => Datalayer.push(layer))
    }
})